module.exports = __webpack_public_path__ + "static/media/third-banner-mobile.a2f299f4.png";